export default "__VITE_ASSET__CGQvLjsH__"